import { corporateGroupTableConfigs } from '../../../../variables'
import buildMetricValuesHook from '../../utils/buildMetricValuesHook'

export const dhWbListLocationGroupGuestDataConfigs = {
  ...corporateGroupTableConfigs,
  googleRating: 'number',
  googleRatingCount: 'number',
  yelpRating: 'number',
  yelpRatingCount: 'number',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  qualtricsOsatPercent: 'percent',
  qualtricsOrderAccuracyPercent: 'percent',
  qualtricsQualityOfFoodPercent: 'percent',
  qualtricsMenuOptionsPercent: 'percent',
  qualtricsValuePercent: 'percent',
  qualtricsEaseOfOrderingPercent: 'percent',
  qualtricsEmployeeFriendlinessPercent: 'percent',
  qualtricsSpeedOfServicePercent: 'percent',
  qualtricsCleanlinessPercent: 'percent',
  qualtricsDriveThruWaitTimePercent: 'percent',
  deliveryCustomerPositiveRatingCountPercentDoordash: 'percent',
} as const

const useDhWbListLocationGroupGuestData = buildMetricValuesHook({
  groupFilterType: 'corporate',
  metrics: {
    codes: [
      'delivery_avg_customer_review_score_doordash',
      'delivery_customer_positive_rating_count_percent_doordash',
    ],
    groups: ['Expo Module - Guest', 'Qualtrics'],
  },
})

export default useDhWbListLocationGroupGuestData
